module.exports = __webpack_public_path__ + "img/linkedin.cc1ca31c.png";